import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

import type { Country, InputProps } from './types';

interface Props extends InputProps {
  countries: Country[];
}

export default function CountryInput({ countries, options, value, onChange }: Props) {
  if (countries.length === 1 || options.country?.show === false) {
    return null;
  }

  return (
    <ManagedFormGroup
      disabled={options.country?.disabled}
      label="Country"
      required
      type="select"
      value={value.countryId}
      onValueChange={countryId => onChange({ ...value, countryId: Number(countryId) })}
    >
      <Options
        labelName="name"
        options={countries}
        valueName="code"
      />
    </ManagedFormGroup>
  );
}
